<div class="w-full">
  <label *ngIf="label" class="block text-sm font-medium text-gray-700 mb-2">
    {{ label }}
    <span *ngIf="isRequired" class="text-red-500 cursor-help relative group">
      *
      <span
        class="absolute left-0 bottom-full mb-1 w-max px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200"
      >
        Este campo es obligatorio
      </span>
    </span>
  </label>
  <input
    *ngIf="control"
    [type]="type"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [readonly]="readonly"
    [attr.autocomplete]="autocomplete"
    class="w-full px-4 py-2 border text-gray-600 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary transition duration-150 ease-in-out"
  />
  <app-show-error
    *ngIf="showError"
    [control]="control"
    [fieldName]="normalizedFieldName"
  >
  </app-show-error>
</div>
